/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Join_TitleInputs */

const en_us2_clubs_join_title = /** @type {(inputs: Clubs_Join_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join a club`)
};

const pt_br2_clubs_join_title = /** @type {(inputs: Clubs_Join_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrar num clube`)
};

const es_419_clubs_join_title = /** @type {(inputs: Clubs_Join_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unirse a un club`)
};

const pt_pt2_clubs_join_title = /** @type {(inputs: Clubs_Join_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrar num clube`)
};

const fr_fr2_clubs_join_title = /** @type {(inputs: Clubs_Join_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejoindre un club`)
};

const de_de2_clubs_join_title = /** @type {(inputs: Clubs_Join_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einem Club beitreten`)
};

const it_it2_clubs_join_title = /** @type {(inputs: Clubs_Join_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entra in un club`)
};

/**
* | output |
* | --- |
* | "Join a club" |
*
* @param {Clubs_Join_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_join_title = /** @type {((inputs?: Clubs_Join_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Join_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_join_title(inputs)
	if (locale === "es-419") return es_419_clubs_join_title(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_join_title(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_join_title(inputs)
	if (locale === "de-DE") return de_de2_clubs_join_title(inputs)
	if (locale === "it-IT") return it_it2_clubs_join_title(inputs)
	return en_us2_clubs_join_title(inputs)
});
export { clubs_join_title as "clubs.join_title" }